import InteriorDesignForm from "../component/InteriorDesignForm";

const CorporateInteriorDesignEdit = () => {
  return <InteriorDesignForm isEditMode={true} />;
};

export default CorporateInteriorDesignEdit;
